/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 2/16/16.
 */
'use strict';

function PartnerEditController(
    _,
    $location,
    $routeParams,
    BreadcrumbService,
    MetadataItemsSearchViewService,
    MetadataItemsViewDataTransformerFactory,
    NotificationService,
    PartnerEditService,
    PermissionsService,
    SearchFilterService,
    SidebarService,
    SubscriptionsService,
    UtilsService
) {

    var self = this;

    let requiredPropertiesForPartner = {
        'properties': ['name', 'value', 'timeZone',
            'dateFormat', 'timeFormat', 'dateTimeFormat', 'numberFormat',
            'artwork', 'serviceableLanguages']
    };

    let requiredPropertiesForChildPartner = {
        'properties': ['name', 'value', 'timeZone',
            'dateFormat', 'timeFormat', 'dateTimeFormat', 'numberFormat',
            'artwork', 'serviceableLanguages']
    };

    var getEditViewData = function () {
        PartnerEditService.getEditData().then(function (editData) {
            self.partnerObject = editData.partner;

            // if its a child partner (e.g. a child of a super
            // partner) and the path matches any of the tabs that
            // should not be accessible then navigate back to the
            // login screen
            if (_.has(editData.partner, 'parentId') &&
                   ($routeParams.editView === 'mvpdItems' ||
                    $routeParams.editView === 'metadataItems' ||
                    $routeParams.editView === 'subscriptions')) {

                // navigate to the login screen
                $location.path('/login');
            } else {
                // show the tabs
                self.activeTabs[$routeParams.editView] = true;
                self.currentViewedTab = $routeParams.editView;
                self.setTabVisibility(editData.partner);
                self.loadingIndicator.show = false;
            }
        });

        PartnerEditService.saveDisabled = self.saveDisabled;
    };

    //=================//
    // Lifecycle Hooks //
    //=================//

    self.$onInit = function () {
        BreadcrumbService.editService = PartnerEditService;
        self.isAdmin = PermissionsService.isAdmin();
        SidebarService.editService = PartnerEditService;
        self.editService = PartnerEditService;

        self.loadingIndicator.show = true;
        SearchFilterService.populateCriteriaFromLocationSearch();
        if ($routeParams.editView === 'mvpdItems') {
            this.columnDefs = MetadataItemsViewDataTransformerFactory.mvpdColumns;
        } else {
            this.columnDefs = MetadataItemsViewDataTransformerFactory.partnerColumns;
        }

        self.permissions = {};
        PartnerEditService.getViewPermissions()
            .then(function (permissions) {
                _.set(self.permissions, 'deliveryEndpoints.read', permissions.deliveryEndpointsRead);
                _.set(self.permissions, 'deliveryEndpoints.write', permissions.deliveryEndpointsWrite);
                _.set(self.permissions, 'deliveryProfiles.read', true);
                _.set(self.permissions, 'deliveryProfiles.write', true);
                _.set(self.permissions, 'emailEndpoints.read', permissions.emailEndpointsRead);
                _.set(self.permissions, 'emailEndpoints.write', permissions.emailEndpointsWrite);
                _.set(self.permissions, 'dueDateTemplates.read', permissions.dueDateTemplatesRead);
                _.set(self.permissions, 'dueDateTemplates.write', permissions.dueDateTemplatesWrite);
                getEditViewData();
            });
    };

    self.$onDestroy = function () {
        self.loadingIndicator.show = false;
        PartnerEditService.saveDisabled = null;
    };

    self.currentViewedTab = '';

    // required property lists, indexed by tab name
    self.requiredProperties = requiredPropertiesForPartner;

    self.activeTabs = {
        properties: false,
        deliveryEndpoints: false,
        deliveryProfiles: false,
        emailEndpoints: false,
        planner: false,
        metadataItems: false,
        mvpdItems: false,
        subscriptions: false,
        dueDateTemplates: false,
        nielsenTemplates: false,
        audioMappingRules: false
    };

    self.validTabs = {
        properties: true,
        deliveryEndpoints: true,
        deliveryProfiles: true,
        emailEndpoints: true,
        planner: true,
        metadataItems: true,
        mvpdItems: true,
        subscriptions: true,
        dueDateTemplates: true,
        nielsenTemplates: true,
        audioMappingRules: true
    };

    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };

    self.onSave = function () {
        self.loadingIndicator.show = true;
        PartnerEditService.saveEditData().then(function () {
            self.partnerObject = PartnerEditService.partnerObject;
            self.setTabVisibility(self.partnerObject);
            self.loadingIndicator.show = false;
        });
    };

    self.onRevert = function () {
        self.partnerObject = PartnerEditService.revertEditData();
    };

    self.onClose = function () {
        PartnerEditService.exitEdit();
    };

    self.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function() {
                var isProcessing = self.loadingIndicator.show;
                var isNew = $routeParams.id <= -1;
                var isPristine = PartnerEditService.editorForm && PartnerEditService.editorForm.$pristine;
                var saveDisabled = PartnerEditService.saveDisabled && PartnerEditService.saveDisabled() === true;
                return !isProcessing && (isNew || !isPristine) && !saveDisabled;
            },
            onClick: self.onSave
        },
        {
            label: 'Revert',
            enabled: function() {
                var isProcessing = self.loadingIndicator.show;
                var isNew = $routeParams.id <= -1;
                var isPristine = PartnerEditService.editorForm && PartnerEditService.editorForm.$pristine;
                return !isProcessing && (isNew || !isPristine);
            },
            onClick: self.onRevert
        },
        {
            label: 'Close',
            enabled: function() { return !self.loadingIndicator.show; },
            onClick: self.onClose
        }
    ];

    self.onTabSelect = function (tabName) {
        PartnerEditService.changeEditTab(tabName);

        self.filterEnabled = (tabName === 'subscriptions');
    };

    self.onTabDeselect = function (tabName, event) {
        if (tabName === 'subscriptions' &&
            SubscriptionsService.editorForm &&
            SubscriptionsService.editorForm.$dirty ||
            !PartnerEditService.canExitEditView()) {
            event.preventDefault();
            NotificationService.createWarningNotification(
                'Please save or revert your changes before navigating away from this page.'
            );
        }
    };

    self.saveDisabled = function () {
        if (!PartnerEditService.partnerObject) {
            return true;
        }
        // "Pre-Delivery Validator" - "Enabled" + required
        // "Delivery Endpoint" check
        if (PartnerEditService.partnerObject.embargoEnabledFlag &&
            !_.has(PartnerEditService, 'partnerObject.embargoDeliveryEndpoint'))
        {
            return true;
        }

        // "Pre-Delivery QC Approval" - "Enabled" + required
        // "Delivery Endpoint" check
        if (PartnerEditService.partnerObject.approvalEnabledFlag &&
            !_.has(PartnerEditService, 'partnerObject.approvalDeliveryEndpoint'))
        {
            return true;
        }

        self.requiredProperties = _.get(PartnerEditService, 'partnerObject.parentId') ? requiredPropertiesForChildPartner : requiredPropertiesForPartner;

        if (self.currentViewedTab in self.requiredProperties) {
            return self.requiredProperties[self.currentViewedTab].reduce(
                function (accum, current) {
                    return accum || !UtilsService.hasData(PartnerEditService.partnerObject[current]);
                },
                false
            );
        }
        return false;
    };

    self.setTabVisibility = (partner) => {
        // if the partner is a child of a super partner, these
        // tabs should not be viewable
        self.validTabs.metadataItems = !partner.parentId;
        self.validTabs.mvpdItems = !partner.parentId;
        self.validTabs.subscriptions = !partner.parentId;

        self.validTabs.dueDateTemplates = self.permissions.dueDateTemplates.read;
    };

    self.getMetadataPropertiesPromise = () => {
        let showMVPD = $routeParams.editView === 'mvpdItems';
        return MetadataItemsSearchViewService.getPartnerMetadataProperties($routeParams.id, showMVPD);
    };
}

angular.module('prism-ui.partner').component('partnerEditView', {
    templateUrl: 'system/partner/editor/partner-edit-template.html',
    controller: PartnerEditController,
    bindings: {
    }
});
